import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromAppstate from './+state/appstate.reducer';
import { AppstateEffects } from './+state/appstate.effects';
import { AppstateFacade } from './+state/appstate.facade';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './+state/loader.interceptor';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromAppstate.APPSTATE_FEATURE_KEY,
      fromAppstate.reducer,
    ),
    EffectsModule.forFeature([AppstateEffects]),
  ],
  providers: [
    AppstateFacade,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  ],
})
export class CignaForBrokersShellDataAccessModule {}
